import axios from "axios";

// Notificaciones de la web (campana del header). La conexión en vivo, el
// sonido, el título y los avisos del sistema viven en Utils/notificaciones.js;
// acá solo el estado y los pedidos a la API.

const API = () => process.env.VUE_APP_API_URL;
const LS_SILENCIO = "hyf_notif_silencio";
const LS_ESCRITORIO = "hyf_notif_escritorio";
const MAX_TOASTS = 3;

const ordenar = (a, b) => (b.fecha || "").localeCompare(a.fecha || "") || b.id - a.id;

export default {
    namespaced: true,
    state: {
        items: [],
        noLeidas: 0,
        cargando: false,
        cargado: false,
        error: false,
        hayMas: false,
        // Preferencias de este navegador.
        silenciado: localStorage.getItem(LS_SILENCIO) === "1",
        escritorio: localStorage.getItem(LS_ESCRITORIO) !== "0",
        // Conversación que el usuario tiene abierta (no se avisa de sus mensajes).
        conversacionAbierta: null,
        toasts: [],
    },
    getters: {
        items: (s) => s.items,
        noLeidas: (s) => s.noLeidas,
    },
    mutations: {
        reset(s) {
            s.items = [];
            s.noLeidas = 0;
            s.cargado = false;
            s.cargando = false;
            s.error = false;
            s.hayMas = false;
            s.toasts = [];
            s.conversacionAbierta = null;
        },
        setLista(s, { items, hayMas, noLeidas, agregar }) {
            const base = agregar ? s.items.slice() : [];
            for (const n of items) {
                if (!base.some((x) => x.id === n.id)) base.push(n);
            }
            s.items = base.sort(ordenar);
            s.hayMas = !!hayMas;
            s.noLeidas = noLeidas;
            s.cargado = true;
            s.error = false;
        },
        setCargando(s, v) { s.cargando = v; },
        setError(s, v) { s.error = v; },
        // Llega por Pusher: nueva o agrupada (mismo id con más cantidad).
        recibir(s, { notificacion, noLeidas }) {
            const resto = s.items.filter((x) => x.id !== notificacion.id);
            s.items = [notificacion, ...resto].sort(ordenar);
            if (typeof noLeidas === "number") s.noLeidas = noLeidas;
        },
        marcarLeidas(s, { ids, todas, noLeidas }) {
            s.items = s.items.map((n) => (todas || ids.includes(n.id) ? { ...n, leida: true } : n));
            if (typeof noLeidas === "number") s.noLeidas = noLeidas;
            else s.noLeidas = s.items.filter((n) => !n.leida).length;
        },
        setSilenciado(s, v) {
            s.silenciado = v;
            localStorage.setItem(LS_SILENCIO, v ? "1" : "0");
        },
        setEscritorio(s, v) {
            s.escritorio = v;
            localStorage.setItem(LS_ESCRITORIO, v ? "1" : "0");
        },
        setConversacionAbierta(s, id) {
            s.conversacionAbierta = id == null ? null : Number(id);
        },
        agregarToast(s, n) {
            const otros = s.toasts.filter((t) => t.id !== n.id);
            s.toasts = [...otros, n].slice(-MAX_TOASTS);
        },
        quitarToast(s, id) {
            s.toasts = s.toasts.filter((t) => t.id !== id);
        },
    },
    actions: {
        async cargar({ commit, state }, { agregar = false } = {}) {
            if (state.cargando) return;
            commit("setCargando", true);
            try {
                const params = { limit: 20 };
                if (agregar && state.items.length) params.antes = state.items[state.items.length - 1].id;
                const { data } = await axios.get(`${API()}notificaciones`, { params });
                commit("setLista", { items: data.items || [], hayMas: data.hay_mas, noLeidas: data.no_leidas || 0, agregar });
            } catch (e) {
                commit("setError", true);
            } finally {
                commit("setCargando", false);
            }
        },
        async leer({ commit, state }, id) {
            const n = state.items.find((x) => x.id === id);
            if (n && n.leida) return;
            commit("marcarLeidas", { ids: [id], noLeidas: Math.max(0, state.noLeidas - 1) });
            try {
                const { data } = await axios.post(`${API()}notificaciones/${id}/leer`);
                commit("marcarLeidas", { ids: [id], noLeidas: data.no_leidas });
            } catch (e) { /* queda como leída en esta pestaña; se corrige al recargar */ }
        },
        async leerEntidad({ commit, state }, { entidad, id }) {
            const hay = state.items.some((n) => !n.leida && n.entidad === entidad && String(n.entidad_id) === String(id));
            if (!hay && state.cargado) return;
            try {
                const { data } = await axios.post(`${API()}notificaciones/leer-entidad`, { entidad, entidad_id: String(id) });
                commit("marcarLeidas", { ids: data.ids || [], noLeidas: data.no_leidas });
            } catch (e) { /* sin red: se corrige en la próxima carga */ }
        },
        async leerTodas({ commit }) {
            commit("marcarLeidas", { ids: [], todas: true, noLeidas: 0 });
            try {
                await axios.post(`${API()}notificaciones/leer-todas`);
            } catch (e) { /* idem */ }
        },
    },
};
